"use client";

import { useState, type ReactNode } from "react";

/** Değeri panoya kopyalar; kısa süre "Kopyalandı" geri bildirimi gösterir. */
export function CopyButton({
  value,
  label,
  copiedLabel,
  className = "",
  children,
}: {
  value: string;
  /** Erişilebilir ad, ör. "Lacivert HEX kodunu kopyala" */
  label: string;
  copiedLabel: string;
  className?: string;
  children: ReactNode;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(value);
          setCopied(true);
          window.setTimeout(() => setCopied(false), 1600);
        } catch {
          // Pano izni yoksa sessiz geç; değer zaten ekranda görünür.
        }
      }}
      className={className}
    >
      <span aria-live="polite">{copied ? copiedLabel : children}</span>
    </button>
  );
}
